module.exports = KsysAppTemplateV2dot15dot10;